/**
 * @file: ServiceEditionProductLine.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum ServiceEditionProductLine {
  Workshop = 'workshop',
  Ai = 'ai',
  Full = 'full',
}

export const ServiceEditionProductLineValueSet = new Set([
  ServiceEditionProductLine.Workshop,
  ServiceEditionProductLine.Ai,
  ServiceEditionProductLine.Full,
]);
